
import { galleryImages } from '../../../mocks/gallery';

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-gray-900 mb-4">
            Design Gallery
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A curated collection of our finest work showcasing diverse styles and exceptional craftsmanship
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer hover:scale-105 transition-transform duration-300 ${
                index % 7 === 0 ? 'col-span-2 row-span-2' : ''
              }`}
            >
              <div className={`relative ${index % 7 === 0 ? 'h-[600px]' : 'h-[290px]'}`}>
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white font-bold text-lg mb-1">{image.title}</p>
                  <p className="text-white/80 text-sm">{image.category}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-4 border-2 border-gray-900 text-gray-900 rounded-full font-medium hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
            View Full Gallery
          </button>
        </div>
      </div>
    </section>
  );
}